import { render, staticRenderFns } from "./sharePageDropdown.vue?vue&type=template&id=5a129de4&scoped=true&"
import script from "./sharePageDropdown.vue?vue&type=script&lang=js&"
export * from "./sharePageDropdown.vue?vue&type=script&lang=js&"
import style0 from "./sharePageDropdown.vue?vue&type=style&index=0&id=5a129de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a129de4",
  null
  
)

export default component.exports